import { render, staticRenderFns } from "./Violation.vue?vue&type=template&id=2b5d295e&"
import script from "./Violation.vue?vue&type=script&lang=ts&"
export * from "./Violation.vue?vue&type=script&lang=ts&"
import style0 from "./Violation.vue?vue&type=style&index=0&id=2b5d295e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports